module.exports = __webpack_public_path__ + "img/icon-check.42da3d7f.svg";